import redirects from '@/config/redirects';

export default function ({ route, store, env: { dev } }) {
    store.redirect = function (location) {
        if (dev && !location.startsWith('/student')) {
            location = `${window.location.protocol}//${window.location.hostname + location}`;
        }

        window.location.replace(location);
    };

    redirects.forEach(([from, to]) => {
        if (from.test(route.path) === false) {
            return;
        }

        window.location.replace(window.location.href.replace(from, to));
    });
}
